import React from 'react';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { useBdaasAirports } from '@/hooks/airportHooks/airportsFetchyeHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import LFLink from '@/components/common/LFLink';
import ChevronLeft from '@/components/icons/ChevronLeft';
import AirportsSearchBox from '@/components/common/AirportsSearchBox';
import CardCalloutNotification from '@/components/common/CardCalloutNotification';
import { getLocaleData } from '@/selectors/localeSelectors';
import { getMarketName } from '@/helpers/utils';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

// this page is used to show all airports available for a specific card product
// however, we currently don't have an endpoint that will return airports by product (access item) so we'll return all
const AllAirportsPage = () => {
  const { data: bdaasAirportsResponse } = useBdaasAirports();
  const { product } = useRouteParams();
  const { allAirports, productDisplayNames } = useCommonContent();

  // get country name from locale
  const { locale } = useSelector(getLocaleData);
  const marketName = getMarketName(locale);

  if (!bdaasAirportsResponse) {
    return (
      <div className="tw-m-12 tw-flex tw-justify-center">
        <ProgressCircular />
      </div>
    );
  }

  const airports = bdaasAirportsResponse.body;

  // sort by airport name
  airports.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="tw-mx-auto tw-max-w-screen-xl tw-px-4 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
      <h1 className="tw-heading-display-small-book tw-mb-6 tw-mt-10">
        {allAirports?.header}
      </h1>

      <div className="tw-rounded-2xl tw-border tw-border-gray-400">
        <div className="tw-p-4 md_tw-p-6">
          <AirportsSearchBox />
        </div>

        <style>
          {`
            .callout > div { 
              border: none;
              border-top-right-radius: 0;
              border-top-left-radius: 0;
            }
          `}
        </style>
        <CardCalloutNotification className="callout tw-border-t tw-border-gray-300" />
      </div>

      <hr className="tw-my-10 tw-border-gray-400" />

      <h2 className="tw-heading-md-regular tw-mb-6">
        {allAirports?.description} {marketName}{' '}
        {productDisplayNames[product]?.displayName?.replace('The', '')}
      </h2>

      <div className="md_ts-grid-cols-2 tw-grid tw-gap-x-6 lg_tw-grid-cols-3">
        {airports.map((airport) => (
          <LFLink
            key={`all-airports-page-link-${airport.iata}`}
            detail={`all-airports-page-link-${airport.iata}`}
            className="tw-items-center tw-py-2dot5 tw-text-link hover_tw-underline"
            to={`${product}/${airport.iata}`}
            element="all-airports-list"
          >
            {airport.name} ({airport.iata})
            <ChevronLeft className="tw-ml-1 tw-inline tw-h-3 tw-w-3 tw-rotate-180" />
          </LFLink>
        ))}
      </div>
    </div>
  );
};

export default AllAirportsPage;
